<script>
    import { onMount } from "svelte";
    import StatusMessage from "../include/StatusMessage.svelte";
    import { api_get } from "../util/api_request";
    import UserCard from "../include/UserCard.svelte";

    let response_msg;

    let users;

    let fetch_users = async () => {
        let response = await api_get("/api/user/player_list");
        if (response.status != 200)
            response_msg = response;

        users = response.data;
    }

    onMount(fetch_users);
</script>

<div class="content">
    <div class="container">
        <h1>Playerlist</h1>
        <p>A list of all players able to join the server currently</p>
        <p>Golden cards signify donors.</p>
        <hr>
        <StatusMessage message={response_msg} />
        <div class="grid">
            {#if users}
            {#each users as user}
            <UserCard user_data={user} />
            {/each}
            {/if}
        </div>
    </div>
</div>

<style>
    .grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
</style>